export default {"src":"/_next/static/media/myself.dc0c69a0.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};